// src/pages/usa/colorado/Golden.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Golden ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function Golden() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__goldenBackRouteSet) {
      window.__goldenBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Golden, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>Discover Golden, Colorado</h2>

            <p>
              Golden sits at the base of the Front Range, just west of Denver. Nestled along Clear Creek, it blends
              mountain charm with historic grit. Known for its walkable downtown, the Colorado School of Mines,
              Coors Brewery, and the National Renewable Energy Lab, Golden offers easy access to Lookout Mountain,
              Clear Creek Trail, and the iconic “Welcome to Golden” arch.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              Most travelers arrive via Denver International Airport (DEN). From there, Golden is about 45 minutes
              by car, shuttle, or RTD light rail. The drive along I‑70 and US‑6 offers scenic foothill views, and
              once in town, Golden’s compact layout makes it easy to explore on foot.
            </p>

            {/* 🌟 PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Downtown Golden:</strong> A modern Old West town with a lively atmosphere. Clear Creek Trail
                  is perfect for walking, tubing, kayaking, or simply relaxing by the water. Fall colors are stunning,
                  and winter lights make the area magical.<br />
                  <a
                    href="https://www.google.com/maps?q=39.75625318047583,-105.22336877669896"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Clear Creek Trail
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Lookout Mountain:</strong> Home to Buffalo Bill’s grave and museum, with sweeping views of
                  Golden and the plains. Popular with cyclists, paragliders, and sightseers.<br />
                  <a
                    href="https://www.google.com/maps?q=39.7336,-105.2372"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Lookout Mountain
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=39.73257708498639,-105.23829598987477"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Buffalo Bill’s Grave
                  </a>
                </div>
              </li>
            </ul>

            {/* 🏔️ HIDDEN GEMS */}
            <h3>🏔️ Hidden Gems in Golden</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Motorcycle Friendly:</strong> Golden is a favorite launch point for riders exploring canyon
                  roads and mountain passes. Scenic loops begin near Coors Brewery and head west through Clear Creek
                  Canyon via US‑6, connecting to CO‑74 toward Evergreen and Morrison.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>North Table Mountain:</strong> Dramatic mesa with excellent hiking and biking trails.<br />
                  <a
                    href="https://www.google.com/maps?q=39.7805,-105.2201"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 North Table Mountain Trailhead
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>South Table Mountain:</strong> Flat‑topped mesa with panoramic views of Golden and Denver.<br />
                  <a
                    href="https://www.google.com/maps?q=39.7557,-105.2123"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 South Table Mountain Trailhead
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Apex Park:</strong> Popular trail system with forested climbs and ridge views.<br />
                  <a
                    href="https://www.google.com/maps?q=39.71739004136781, -105.2265014493436"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Apex Park Trailhead
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Chimney Gulch:</strong> Steep trail connecting Golden to Lookout Mountain.<br />
                  <a
                    href="https://www.google.com/maps?q=39.7500831297869, -105.2302504574331"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Chimney Gulch Trailhead
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Windy Saddle:</strong> Scenic overlook between Golden and Lookout Mountain.<br />
                  <a
                    href="https://www.google.com/maps?q=39.73674021631485, -105.245462333596967"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Windy Saddle Park
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Mount Galbraith:</strong> Rocky mountain trail with sweeping views of Golden.<br />
                  <a
                    href="https://www.google.com/maps?q=39.76491913673436, -105.25230910290614"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Mount Galbraith Trailhead
                  </a>
                </div>
              </li>
            </ul>

            {/* 🛏️ PLACES TO STAY */}
            <h3>🛏️ Places to Stay in Golden</h3>

            <p>
              Golden offers year‑round lodging options that blend comfort, history, and mountain charm. Whether you're
              visiting for outdoor adventures, Red Rocks concerts, or a quiet weekend getaway, these top‑rated hotels
              offer something for every traveler.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>The Golden Hotel, Ascend Collection:</strong> Boutique hotel along Clear Creek with walkable access to downtown.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Table Mountain Inn:</strong> Southwestern‑style hotel with spacious rooms and great location.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Origin Red Rocks:</strong> Official Red Rocks partner hotel with shuttle service.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hampton Inn Denver West/Golden:</strong> Reliable, clean, family‑friendly.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>The Eddy Taproom & Hotel:</strong> Boutique stay with rooftop terrace and taproom.
                </div>
              </li>
            </ul>

            {/* AFFILIATE BLOCK */}
          <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                      <div className="affiliate-block">
                        <AffiliateExpedia />
                        <AffiliateBooking />
                        <AffiliateTrip />
                      </div>

            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos of Golden:</p>

            <p>
              <a
                href="https://youtu.be/fQOVqvmLIPM?si=1lyDXG1FWZ2k3MJv"
                target="_blank"
                rel="noopener noreferrer"
              >
                Golden Town
              </a>
              <br />
              <a
                href="https://youtu.be/Eb09TmHs0t8?si=mlyiCdE6PIYtkRId"
                target="_blank"
                rel="noopener noreferrer"
              >
                From Lookout Mountain to Golden
              </a>
              <br />
              <a
                href="https://youtu.be/-exOruk83jI?si=cqCYKIEqb1NEBzlf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Clear Creek Trail
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/fQOVqvmLIPM?si=1lyDXG1FWZ2k3MJv"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/golden/signofgolden.jpg"
                alt="Golden Town Video"
              />
            </a>

            <a
              href="https://youtu.be/Eb09TmHs0t8?si=mlyiCdE6PIYtkRId"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/golden/ggg.jpg"
                alt="From Lookout Mountain to Golden Video"
              />
            </a>
              <a
              href="https://youtu.be/-exOruk83jI?si=cqCYKIEqb1NEBzlf"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/golden/clearcreekfall.jpg"
                alt="Clear Creek Trail Video"
              />
            </a>

            
            <img src="/images/usa/colorado/golden/clearcreektrees.jpg" alt="Clear Creek Trees During Fall" />
            <img src="/images/usa/colorado/golden/clearcreekfromthebridge.jpg" alt="Clear Creek From the Bridge" />
            <img src="/images/usa/colorado/golden/clearcreekriver.jpg" alt="Clear Creek River" />
            <img src="/images/usa/colorado/golden/clearcreekfrozen.jpg" alt="Clear Creek Frozen" />
            <img src="/images/usa/colorado/golden/lookoutmountaingiftshop.jpg" alt="Lookout Mountain Giftshop" />
            <img src="/images/usa/colorado/golden/lookoutmountainparking.jpg" alt="Lookout Mountain Parking" />
            <img src="/images/usa/colorado/golden/goldenstreet.jpg" alt="Golden Street" />
            <img src="/images/usa/colorado/golden/goldendowntown.jpg" alt="Golden Downtown" />
            <img src="/images/usa/colorado/golden/coorsandsouthtable.jpg" alt="Coors and South Table" />
            <img src="/images/usa/colorado/golden/golden.jpg" alt="Golden" />
            <img src="/images/usa/colorado/golden/woodyspizza.jpg" alt="Woodys Pizza" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
